import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import { bindActionCreators } from 'redux';
import { deleteReclamationInEdit, getReclamation } from '../actions';
import { selectReclamationInEdit } from '../reducer';
import ReclamationFormWrapper from './ReclamationFormWrapper';

const ReclamationEdit = (props) => {
  const params = useParams();
  const location = useLocation();
  const reclamationInEdit = useSelector(selectReclamationInEdit);
  const routeReclamation = location.state?.initialReclamation;
  const reclamationId = Number(params.reclamation);
  const initialReclamation =
    !Number.isFinite(reclamationId) || Number(reclamationInEdit?.id) === reclamationId
      ? reclamationInEdit
      : routeReclamation;

  useEffect(() => {
    props.getReclamation(params.reclamation);
    return () => {
      props.deleteReclamationInEdit();
    };
  }, []);

  return (
    initialReclamation && (
      <div data-testid="reclamationEdit">
        <ReclamationFormWrapper
          initialReclamation={initialReclamation}
          isNew={false}
          completeMode={props.completeMode}
          location={location}
        />
      </div>
    )
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getReclamation, deleteReclamationInEdit }, dispatch);
};

export default connect(null, mapDispatchToProps)(ReclamationEdit);
